import { useState } from "react";
import { Box, Popover } from "@mui/material";
import { SketchPicker } from "react-color";

/**
 * Note: there is a small delay (~100ms) when using onChange on SketchPicker
 * to avoid firing hundreds of events per second and freezing React.
 *
 * Modes:
 *  - direct (`direct`=true)
 *  - delayed (`direct`=false)
 *
 * Direct Mode - `color` value is used directly in picker, `setColor` is called directly on color change (onChange)
 * Delayed Mode - intermediary `selectedColor` value is used in picker, `setColor` is called on Popover close (onClose)
 *
 */
const ColorPicker = ({
  color,
  setColor,
  circleStyles = {},
  presetColors = [],
  direct = false,
  size = 35,
}) => {
  const [selectedColor, setSelectedColor] = useState(color);
  const [colorAnchorEl, setColorAnchorEl] = useState(null);

  const handleClickChangeColor = (event) =>
    setColorAnchorEl(event.currentTarget);

  const handleCloseColorPicker = () => {
    setColorAnchorEl(null);
    if (!direct) setColor(selectedColor);
  };

  const onColorChange = (updatedColor) => {
    const hex = updatedColor.hex;
    direct ? setColor(hex) : setSelectedColor(hex);
  };

  const openColorPicker = Boolean(colorAnchorEl);
  const currentColor = direct ? color : selectedColor;

  return (
    <>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: currentColor,
          cursor: "pointer",
          borderRadius: "50%",
          ...circleStyles,
        }}
        onClick={handleClickChangeColor}
      />
      <Popover
        open={openColorPicker}
        anchorEl={colorAnchorEl}
        onClose={handleCloseColorPicker}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <SketchPicker
          disableAlpha={true}
          color={currentColor}
          onChange={onColorChange}
          presetColors={presetColors}
        />
      </Popover>
    </>
  );
};

export default ColorPicker;
